import $ from 'jquery';

$(document).ready(() => {
  const $showContent = $('.js-show-content');
  const $facadeContent = $('.js-content');
  const ACTIVE = 'is-active';

  if ($showContent.length) {
    $showContent.on('click', (e) => {
      const $this = $(e.currentTarget);
      if (!$this.siblings($facadeContent).hasClass(ACTIVE)) {
        $facadeContent.stop().slideUp().removeClass(ACTIVE);
        $showContent.removeClass(ACTIVE);
        $this.addClass(ACTIVE);
        $this.siblings($facadeContent).stop().slideDown().addClass(ACTIVE);
      } else {
        $this.removeClass(ACTIVE);
        $this.siblings($facadeContent).stop().slideUp().removeClass(ACTIVE);
      }
    });
  }
});
